import { geography } from "./categories/geography"
import { sociology } from "./categories/sociology";

export const trivia = [
    {
        title: "Географија",
        data: geography
    },
    {
        title: "Социологија",
        data: sociology
    }
];
